import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  templateUrl: "CreateOrganizationDialog.component.html",
})
export class CreateOrganizationDialogComponent {
  public constructor(
    public dialogRef: MatDialogRef<CreateOrganizationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string
  ) {}

  public onNoClick(): void {
    this.dialogRef.close();
  }
}
